package horcrux.browserapp.externals.firebase

import kotlin.js.json

internal fun Iterable<Pair<String, Any?>>.filterIfValueIsNull(): List<Pair<String, Any>> {
    @Suppress("UNCHECKED_CAST")
    return this.filter { it.second != null } as List<Pair<String, Any>>
}

internal fun List<Pair<String, Any?>>.toJson() = run {
    json(*this.toTypedArray())
}

internal fun jsonWithoutNullValues(vararg pairs: Pair<String, Any?>) = pairs.toList().filterIfValueIsNull().toJson()
